import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import FaqService from "../Services/FaqService";

export const Faqs = () => {
    const [heading, setHeading] = useState("");
    const [description, setDescription] = useState("");
    const [showLoader, setShowLoader] = useState<any>(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setShowLoader(true);
        FaqService.getFaqUser()
            .then((response) => {
                if (response.data) {
                    setHeading(response.data.heading)
                    setDescription(response.data.description)
                }
                setShowLoader(false);
            });
    }
    return (
        <>
            <main>
                {showLoader &&
                    <div className="loader-backdrop">
                        <Spinner animation="border" variant="primary" />
                    </div>
                }
                <div className="hero-banner hero-banner--background hero-banner--subpage">
                    <div className="container">
                        <div className="hero-banner__image-container">
                            {heading && description && (
                                <>
                                    <div className="my-4">
                                        <h1>{heading}</h1>
                                    </div>
                                    <div className="card-body ps-3">
                                        <div dangerouslySetInnerHTML={{ __html: description }} />
                                    </div>
                                </>
                            )}
                            {!heading && !description && (
                                <>
                                    <div className="my-4">
                                        <h1>There are no FAQs added by admin</h1>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}